import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import {
  isValidMaxDecimalPlaces,
  convertToNullWhenNaN
} from 'utils/validation';

const MAX_DECIMAL_PLACES_FOR_DAYS = 1;
const MAX_DECIMAL_PLACES_FOR_HOURS = 2;

const t = i18n.getFixedT(getLocale(), 'common');

export const schema = yup.object({
  pYear: yup.number(),
  pPeriod: yup.number(),
  periodTypeSvc: yup.string(), // TODO select
  socialSecurityDays: yup
    .number()
    .transform(convertToNullWhenNaN)
    .nullable()
    .min(
      0,
      t('validationMinNumber', {
        name: t('holidayHours.grid.socialSecurityDays'),
        number: 0
      })
    )
    .max(
      9999.99,
      t('validationMaxNumber', {
        name: t('holidayHours.grid.socialSecurityDays'),
        number: 9999.99
      })
    )
    .test(
      'isValidMaxDecimalPlaces',
      t('validationNumberMaxDecimals', { number: MAX_DECIMAL_PLACES_FOR_DAYS }),
      (value) => isValidMaxDecimalPlaces(value, MAX_DECIMAL_PLACES_FOR_DAYS)
    )
    .required(t('holidayHours.errors.socialSecurityDaysRequired')),
  holidayHours: yup
    .number()
    .transform(convertToNullWhenNaN)
    .nullable()
    .min(
      0,
      t('validationMinNumber', {
        name: t('holidayHours.grid.holidayHours'),
        number: 0
      })
    )
    .max(
      9999.99,
      t('validationMaxNumber', {
        name: t('holidayHours.grid.holidayHours'),
        number: 9999.99
      })
    )
    .test(
      'isValidMaxDecimalPlaces',
      t('validationNumberMaxDecimals', {
        number: MAX_DECIMAL_PLACES_FOR_HOURS
      }),
      (value) => isValidMaxDecimalPlaces(value, MAX_DECIMAL_PLACES_FOR_HOURS)
    )
    .optional()
});
